/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./extend-node (ignored)
// module id = 2
// module chunks = main